import React from 'react';
import { Animated } from 'react-animated-css';
import BlackOverlay from '../../partials/black_overlay';
import moment from 'moment';
import _ from 'lodash';
import fakeAuth from '../../../fakeAuth';

const CATEGORIES = ['Ropa de Cama', 'Toallas', 'Baño', 'Amenities', 'Limpieza', 'Otros'];

const CATEGORY_COLORS = {
    'Ropa de Cama': '#1fa2ff',
    'Toallas': '#00b4d8',
    'Baño': '#9b5de5',
    'Amenities': '#00c896',
    'Limpieza': '#f7b731',
    'Otros': '#9a9a9a',
};

const UNITS = ['unidad', 'par', 'juego', 'litro', 'ml', 'kg', 'g', 'rollo', 'caja', 'paquete'];

class Inventory extends React.Component {
    state = {
        category_filter: 'Todos',
        showing_item: null,
        adding_item: false,
        editing_item: null,
        movement_type: 1,
        movement_qty: '',
        movement_notes: '',
        item_form: { Name: '', Category: 'Ropa de Cama', Unit: 'unidad', Stock: 0, MinStock: 0 },
        saving: false,
    }

    componentWillMount() {
        const { params, housekeeping_actions } = this.props;
        housekeeping_actions && housekeeping_actions.fetch_items(params.id);
    }

    componentWillReceiveProps(nextProps) {
        const { hk_items = [] } = nextProps;
        const { showing_item } = this.state;
        if (showing_item) {
            const updated = _.find(hk_items, i => i.IdItem === showing_item.IdItem);
            if (updated) this.setState({ showing_item: updated });
        }
    }

    onShowItem = (item) => {
        const { housekeeping_actions } = this.props;
        this.props.dispatch && this.props.dispatch({ type: 'HK_MOVEMENTS/CLEAR' });
        this.setState({ showing_item: item, movement_qty: '', movement_notes: '', movement_type: 1 });
        housekeeping_actions && housekeeping_actions.fetch_movements(item.IdItem);
    }

    onRegisterMovement = () => {
        const { showing_item, movement_type, movement_qty, movement_notes } = this.state;
        const { housekeeping_actions, params } = this.props;
        const qty = parseFloat(movement_qty);
        if (!qty || qty <= 0) return;
        const user = fakeAuth.getUser();
        housekeeping_actions && housekeeping_actions.register_movement({
            IdItem: showing_item.IdItem,
            IdProperty: params.id,
            Type: movement_type,
            Quantity: qty,
            Notes: movement_notes,
            IdStaff: user.IdStaff || null,
        });
        this.setState({ movement_qty: '', movement_notes: '' });
    }

    onSaveItem = () => {
        const { item_form, editing_item, saving } = this.state;
        const { housekeeping_actions, params } = this.props;
        if (saving || !item_form.Name.trim()) return;
        this.setState({ saving: true });
        if (editing_item) {
            housekeeping_actions && housekeeping_actions.update_item({
                IdItem: editing_item,
                IdProperty: params.id,
                Name: item_form.Name,
                Category: item_form.Category,
                Unit: item_form.Unit,
                MinStock: item_form.MinStock,
            });
        } else {
            housekeeping_actions && housekeeping_actions.create_item({
                id: params.id,
                Name: item_form.Name,
                Category: item_form.Category,
                Unit: item_form.Unit,
                Stock: item_form.Stock,
                MinStock: item_form.MinStock,
            });
        }
        this.setState({ adding_item: false, editing_item: null, saving: false, item_form: { Name: '', Category: 'Ropa de Cama', Unit: 'unidad', Stock: 0, MinStock: 0 } });
    }

    onDeleteItem = (item) => {
        const { housekeeping_actions, params } = this.props;
        housekeeping_actions && housekeeping_actions.delete_item({ id: item.IdItem, IdProperty: params.id });
        this.setState({ showing_item: null });
    }

    renderCategoryBadge = (category) => {
        const color = CATEGORY_COLORS[category] || '#9a9a9a';
        return (
            <span className="font-8 poppins" style={{ background: color + '25', color, borderRadius: 4, padding: '2px 6px', whiteSpace: 'nowrap' }}>
                {category}
            </span>
        );
    }

    renderItemCard = (item) => {
        const { showing_item } = this.state;
        const isSelected = showing_item && showing_item.IdItem === item.IdItem;
        const isLow = parseFloat(item.MinStock) > 0 && parseFloat(item.Stock) <= parseFloat(item.MinStock);
        return (
            <figure key={item.IdItem}
                onClick={() => this.onShowItem(item)}
                className={`pointer bg-gray-2 d-flex flex-column m-2 p-3 black-input ${isSelected ? 'white-border' : ''}`}
                style={{ width: 170, minHeight: 155, borderRadius: 8, position: 'relative', cursor: 'pointer' }}>

                {isLow && (
                    <div style={{ position: 'absolute', top: 8, right: 8 }}>
                        <i className="fas fa-exclamation-triangle font-10" style={{ color: '#f7b731' }} title="Stock bajo mínimo" />
                    </div>
                )}

                <div className="mb-1">{this.renderCategoryBadge(item.Category)}</div>
                <span className="white poppins font-14 mt-1" style={{ lineHeight: '1.3' }}>{item.Name}</span>

                <div className="mt-auto pt-2 d-flex align-items-end">
                    <span className="poppins font-28" style={{ color: isLow ? '#f7b731' : '#00c896', lineHeight: 1 }}>
                        {parseFloat(item.Stock).toFixed(0)}
                    </span>
                    <span className="gray poppins font-8 ms-1 mb-1">{item.Unit}</span>
                </div>
                {parseFloat(item.MinStock) > 0 && (
                    <span className="gray font-8 poppins">mín: {parseFloat(item.MinStock).toFixed(0)}</span>
                )}
            </figure>
        );
    }

    renderStats = () => {
        const { hk_items = [] } = this.props;
        const low = hk_items.filter(i => parseFloat(i.MinStock) > 0 && parseFloat(i.Stock) <= parseFloat(i.MinStock)).length;
        return (
            <div className="d-flex mb-3" style={{ gap: 12 }}>
                <div className="bg-gray-2 black-input p-3 d-flex flex-column" style={{ borderRadius: 8, minWidth: 110 }}>
                    <span className="gray font-8 poppins">Total items</span>
                    <span className="white poppins font-24">{hk_items.length}</span>
                </div>
                {low > 0 && (
                    <div className="bg-gray-2 black-input p-3 d-flex flex-column" style={{ borderRadius: 8, minWidth: 110 }}>
                        <span className="font-8 poppins" style={{ color: '#f7b731' }}>Bajo mínimo</span>
                        <span className="poppins font-24" style={{ color: '#f7b731' }}>{low}</span>
                    </div>
                )}
            </div>
        );
    }

    renderItemDetail = () => {
        const { showing_item, movement_type, movement_qty, movement_notes } = this.state;
        const { hk_movements = [] } = this.props;
        if (!showing_item) return null;
        const isLow = parseFloat(showing_item.MinStock) > 0 && parseFloat(showing_item.Stock) <= parseFloat(showing_item.MinStock);
        const qty = parseFloat(movement_qty);
        const canRegister = qty > 0;

        return (
            <div style={{ width: 320, flexShrink: 0 }}>
                <div className="bg-gray-2 black-input p-3" style={{ borderRadius: 8 }}>

                    {/* Header */}
                    <div className="d-flex align-items-start mb-2">
                        <div style={{ flex: 1, minWidth: 0 }}>
                            {this.renderCategoryBadge(showing_item.Category)}
                            <h5 className="white poppins mt-1 mb-0" style={{ fontSize: 16 }}>{showing_item.Name}</h5>
                        </div>
                        <button className="btn btn-link p-0 ms-2" title="Editar" onClick={() => {
                            this.setState({
                                adding_item: true,
                                editing_item: showing_item.IdItem,
                                item_form: {
                                    Name: showing_item.Name,
                                    Category: showing_item.Category,
                                    Unit: showing_item.Unit,
                                    MinStock: showing_item.MinStock,
                                    Stock: showing_item.Stock,
                                }
                            });
                        }}>
                            <i className="fas fa-pen white font-10" />
                        </button>
                        <button className="btn btn-link p-0 ms-2" onClick={() => this.setState({ showing_item: null })}>
                            <i className="fas fa-times gray font-12" />
                        </button>
                    </div>

                    {/* Stock display */}
                    <div className="d-flex align-items-end mb-3">
                        <span className="poppins font-36" style={{ color: isLow ? '#f7b731' : '#00c896', lineHeight: 1 }}>
                            {parseFloat(showing_item.Stock).toFixed(0)}
                        </span>
                        <span className="gray poppins font-12 ms-2 mb-1">{showing_item.Unit}</span>
                        {isLow && (
                            <span className="ms-2 mb-1 font-8 poppins" style={{ color: '#f7b731' }}>
                                ⚠ mín {parseFloat(showing_item.MinStock).toFixed(0)}
                            </span>
                        )}
                    </div>

                    {/* Register movement */}
                    <div className="mb-3">
                        <div className="d-flex mb-2" style={{ gap: 6 }}>
                            <button onClick={() => this.setState({ movement_type: 1 })}
                                className={`btn btn-sm poppins font-10 flex-grow-1 ${movement_type === 1 ? 'btn-blue white' : 'btn-gray-2 gray'}`}>
                                <i className="fas fa-plus me-1" />Entrada
                            </button>
                            <button onClick={() => this.setState({ movement_type: 2 })}
                                className={`btn btn-sm poppins font-10 flex-grow-1 ${movement_type === 2 ? '' : 'btn-gray-2 gray'}`}
                                style={movement_type === 2 ? { background: '#f44336', color: 'white' } : {}}>
                                <i className="fas fa-minus me-1" />Consumo
                            </button>
                        </div>
                        <div className="d-flex" style={{ gap: 6 }}>
                            <input type="number" min="0" step="1"
                                className="form-control black-input white poppins font-12" style={{ background: '#0e1115', color: 'white' }}
                                placeholder="Cantidad"
                                value={movement_qty}
                                onChange={e => this.setState({ movement_qty: e.target.value })}
                                style={{ width: 90 }}
                                onKeyDown={e => e.key === 'Enter' && this.onRegisterMovement()}
                            />
                            <input type="text"
                                className="form-control black-input white poppins font-12" style={{ background: '#0e1115', color: 'white' }}
                                placeholder="Nota (opcional)"
                                value={movement_notes}
                                onChange={e => this.setState({ movement_notes: e.target.value })}
                                onKeyDown={e => e.key === 'Enter' && this.onRegisterMovement()}
                                style={{ flex: 1 }}
                            />
                            <button onClick={this.onRegisterMovement} disabled={!canRegister}
                                className={`btn btn-sm white ${canRegister ? (movement_type === 1 ? 'btn-blue' : '') : 'btn-gray-2'}`}
                                style={canRegister && movement_type === 2 ? { background: '#f44336' } : {}}>
                                <i className="fas fa-check" />
                            </button>
                        </div>
                    </div>

                    {/* Movement history */}
                    <div>
                        <span className="gray font-8 poppins toUpper">Historial reciente</span>
                        <div style={{ maxHeight: 220, overflowY: 'auto', marginTop: 6 }}>
                            {hk_movements.length === 0 && (
                                <span className="gray font-10 poppins d-block mt-1">Sin movimientos registrados</span>
                            )}
                            {hk_movements.map((m, i) => (
                                <div key={i} className="d-flex align-items-center py-1" style={{ borderBottom: '1px solid #2a2f36' }}>
                                    <span className="poppins font-10 me-2" style={{ color: m.Type === 1 ? '#00c896' : '#f44336', minWidth: 30 }}>
                                        {m.Type === 1 ? '+' : '-'}{parseFloat(m.Quantity).toFixed(0)}
                                    </span>
                                    <span className="gray poppins font-8 flex-grow-1" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {m.Notes || (m.FirstName ? `${m.FirstName} ${m.LastName}` : '')}
                                    </span>
                                    <span className="gray poppins font-8 ms-1" style={{ whiteSpace: 'nowrap' }}>
                                        {moment(m.CreatedAt).format('DD/MM HH:mm')}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Delete */}
                    <div className="mt-3 d-flex justify-content-end">
                        <button onClick={() => this.onDeleteItem(showing_item)} className="btn btn-link p-0" style={{ color: '#f44336' }}>
                            <i className="fas fa-trash-alt me-1 font-10" />
                            <span className="font-8 poppins">Eliminar item</span>
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    renderAddForm = () => {
        const { adding_item, item_form, editing_item, saving } = this.state;
        return (
            <Animated animateOnMount={false} animationIn='fadeIn' animationInDuration={200} animationOutDuration={200} animationOut='fadeOut' isVisible={adding_item}>
                <BlackOverlay />
                <div className="d-flex justify-content-center" style={{ position: 'fixed', top: 0, bottom: 0, left: 100, right: 0, zIndex: 1 }}>
                    <div className="black-input bg-gray-2 p-4 align-self-center" style={{ width: 440 }}>
                        <h5 className="white poppins text-center">{editing_item ? 'Editar item' : 'Nuevo item de inventario'}</h5>
                        <hr className="w-50 mx-auto" />

                        <div className="mb-3">
                            <label className="white poppins font-10">Nombre <i className="blue">*</i></label>
                            <input className="form-control black-input white poppins mt-1" style={{ background: '#0e1115', color: 'white' }}
                                value={item_form.Name}
                                onChange={e => this.setState({ item_form: { ...item_form, Name: e.target.value } })}
                                placeholder="Ej: Sábanas queen size"
                                autoFocus
                            />
                        </div>

                        <div className="mb-3">
                            <label className="white poppins font-10">Categoría</label>
                            <select className="form-control black-input white poppins mt-1" style={{ background: '#0e1115', color: 'white' }}
                                value={item_form.Category}
                                onChange={e => this.setState({ item_form: { ...item_form, Category: e.target.value } })}
                                style={{ background: '#0e1115', color: 'white' }}>
                                {CATEGORIES.map(c => <option key={c} value={c} style={{ background: '#0e1115', color: 'white' }}>{c}</option>)}
                            </select>
                        </div>

                        <div className="mb-3 d-flex" style={{ gap: 12 }}>
                            <div style={{ flex: 1 }}>
                                <label className="white poppins font-10">Unidad de medida</label>
                                <select className="form-control black-input white poppins mt-1" style={{ background: '#0e1115', color: 'white' }}
                                    value={item_form.Unit}
                                    onChange={e => this.setState({ item_form: { ...item_form, Unit: e.target.value } })}
                                    style={{ background: '#0e1115', color: 'white' }}>
                                    {UNITS.map(u => <option key={u} value={u} style={{ background: '#0e1115', color: 'white' }}>{u}</option>)}
                                </select>
                            </div>
                            {!editing_item && (
                                <div style={{ width: 110 }}>
                                    <label className="white poppins font-10">Stock inicial</label>
                                    <input type="number" min="0"
                                        className="form-control black-input white poppins mt-1" style={{ background: '#0e1115', color: 'white' }}
                                        value={item_form.Stock}
                                        onChange={e => this.setState({ item_form: { ...item_form, Stock: e.target.value } })}
                                    />
                                </div>
                            )}
                            <div style={{ width: 110 }}>
                                <label className="white poppins font-10">Stock mínimo</label>
                                <input type="number" min="0"
                                    className="form-control black-input white poppins mt-1" style={{ background: '#0e1115', color: 'white' }}
                                    value={item_form.MinStock}
                                    onChange={e => this.setState({ item_form: { ...item_form, MinStock: e.target.value } })}
                                />
                            </div>
                        </div>

                        <div className="d-flex justify-content-center mt-4" style={{ gap: 10 }}>
                            <button onClick={() => this.setState({ adding_item: false, editing_item: null })}
                                className="btn btn-gray-2 white poppins">
                                <i className="fas fa-times me-1" />Cancelar
                            </button>
                            <button onClick={this.onSaveItem} disabled={!item_form.Name.trim() || saving}
                                className={`btn ${item_form.Name.trim() ? 'btn-blue' : 'btn-gray-2'} white poppins`}>
                                <i className="fas fa-check me-1" />Guardar
                            </button>
                        </div>
                    </div>
                </div>
            </Animated>
        );
    }

    render() {
        const { hk_items = [] } = this.props;
        const { category_filter, showing_item } = this.state;
        const filtered = category_filter === 'Todos' ? hk_items : hk_items.filter(i => i.Category === category_filter);

        return (
            <div className="px-1 pt-3">
                {this.renderStats()}

                {/* Category pills + Add button */}
                <div className="d-flex flex-wrap align-items-center mb-3" style={{ gap: 8 }}>
                    {['Todos', ...CATEGORIES].map(cat => (
                        <button key={cat}
                            onClick={() => this.setState({ category_filter: cat })}
                            className={`btn btn-sm poppins font-10 ${category_filter === cat ? 'btn-blue white' : 'btn-gray-2 gray'}`}
                            style={{ borderRadius: 20 }}>
                            {cat}
                        </button>
                    ))}
                    <button onClick={() => this.setState({ adding_item: true, editing_item: null, showing_item: null, item_form: { Name: '', Category: 'Ropa de Cama', Unit: 'unidad', Stock: 0, MinStock: 0 } })}
                        className="btn btn-sm btn-blue white poppins font-10 ms-auto">
                        <i className="fas fa-plus me-1" />Nuevo Item
                    </button>
                </div>

                {/* Main content: item grid + detail panel */}
                <div className="d-flex" style={{ gap: 16, alignItems: 'flex-start' }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        {filtered.length === 0 && (
                            <div className="d-flex flex-column align-items-center py-5">
                                <i className="fas fa-boxes gray font-40" />
                                <span className="gray poppins font-14 mt-3">
                                    {hk_items.length === 0 ? 'No hay items de inventario' : 'No hay items en esta categoría'}
                                </span>
                                <span className="gray poppins font-10 mt-1">Agrega uno con el botón "Nuevo Item"</span>
                            </div>
                        )}
                        <div className="d-flex flex-wrap">
                            {filtered.map(item => this.renderItemCard(item))}
                        </div>
                    </div>

                    {showing_item && this.renderItemDetail()}
                </div>

                {this.renderAddForm()}
            </div>
        );
    }
}

export default Inventory;
